<template>
    <div>
        <my-header @userInfo="getuserInfo"></my-header>
        <div class="cooperation">
            <div class="content">
                <div class="cooperation-header">
                    <img src="@images/cooperation/hzjg_logo.png" alt="" />
                    <h1>合作机构</h1>
                    <div class="bothclear"></div>
                </div>
                <div class="jgsection">
                    <ul>
                        <li v-for="(v,i) in $store.state.hzjglist" :key="i">
                            <a :href="v.href" target="_blank">
                                <img :src="v.img"  :alt="v.alt" />
                            </a>        
                        </li>
                        <div class="bothclear"></div>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    head: {
        title: '合作机构·电子保函查验平台'
    },
    data: () => ({
        userInfo:'',
    }),
    methods: {
        getuserInfo(data){
            this.userInfo=data;
        },
    },
    created() {
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    .header{
        background-image: url(~@images/guarantee/banner2.jpg);  
        background-repeat: no-repeat;
        background-position:0 -56px;
        background-size:cover;    
    }
    .bothclear{
        clear: both;
    }
    .cooperation{
        font-family: Microsoft YaHei;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        min-height:594px;
        background: #f9fafb;
        .content{
            .cooperation-header{
                width:100%;
                padding:40px 0 35px 0;
                line-height:38px;
                img{
                    display:block;
                    float: left;
                }
                h1{
                    float: left;
                    font-size: 30px;
                    margin-left:21px;
                }
            }

            .jgsection{
                width: 100%;
                background-color: #ffffff;
                box-shadow: 0px 3px 12px 0px  rgba(152, 157, 171, 0.08);
                padding:34px 0;
                margin-bottom:40px;
                ul{
                    width:1128px;
                    margin:0 auto;
                    li{
                        float: left;
                        width: 208px;
                        height:92px;
                        margin-right:59px;
                        img{
                            width:100%;
                            height:92px;
                            display: inline-block;
                        }
                        img:hover{
                            transform: scale(1.1);
                        }
                    }
                }
            }

        }

    }
   
</style>
